import { Group } from "three";
import { KitchenService } from "../../../../3d/services/KitchenService/KitchenService";
import { IItemCreateObjectData } from "../FormModule/FormModule";
import { TAspectData } from "../../../../../common-code/types/TAspectData";

export const frontCameraAspect = (
  service: KitchenService,
  itemModule: IItemCreateObjectData
): TAspectData => {
  let yCoord = service?.sceneChildren().filter((el) => el instanceof Group)[0]
    .position.y;

  if (!yCoord) return service.getDefaultAspect();

  let frontAspect;
  let moduleHeight = +itemModule.heightText
    .split("")
    .filter((el) => el !== " " && !el.includes("м"))
    .join("");

  frontAspect = {
    target: {
      x: 0,
      y: yCoord,
      z: 0,
    },
    camera: {
      x: 0,
      y: yCoord > 1700 ? yCoord - 500 : yCoord + 500,
      z: moduleHeight > 1000 ? 3000 : 1700,
    },
  };

  return frontAspect;
};
